module.exports = __webpack_public_path__ + "img/34.4fa235cc.png";